(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/ball-row-banner.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/ball-row-banner.js');


'use strict';

const _excluded = ["htmlElement", "bannerOptions"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};


const Animations = svs.tur.ball.row.animations.Core;
class RowBanner extends svs.tur.Base {
  constructor(_ref) {
    let htmlElement = _ref.htmlElement,
      bannerOptions = _ref.bannerOptions,
      props = _objectWithoutProperties(_ref, _excluded);
    super(_objectSpread({
      htmlElement,
      className: 'ball-row'
    }, props));
    this.createDomElements(bannerOptions);
  }
  createDomElements() {
    this.$inner = this.createElement('inner');
    if (this.htmlElement) {
      if (typeof this.htmlElement === 'string') {
        this.$inner.innerHTML = this.htmlElement;
      } else {
        this.$inner.appendChild(this.htmlElement);
      }
    }
    this.$el.appendChild(this.$inner);
    if (this.size) {
      this.$el.setAttribute('data-size', this.size);
    }
  }
  show() {
    this.$el.style.display = '';
    Animations.fadeIn(this);
  }
  hide() {
    const tl = gsap.timeline();
    tl.add(Animations.fadeOut(this)).then(() => this.$el.style.display = 'none');
  }
  slideIn() {
    return Animations.slideIn(this);
  }

  prepare() {}
  classNames() {
    return ['ball-row-banner'];
  }
  render() {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!visible) {
      this.$el.style.opacity = 0;
    }
    return this.$el;
  }
}
svs.tur.ball.row.Banner = RowBanner;

 })(window);